<template>
  <div class="site-notify toast-container position-fixed top-0 start-50 translate-middle-x">
    <div ref="toastRef" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <div>{{ messageRef }}</div>
        <div>
          <button type="button" class="btn btn-primary btn-sm" @click="onAction">Action</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.toast-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>

<script setup lang="ts">
import { ref } from 'vue'
import { Toast } from 'bootstrap'
import { SiteNotifyEventArgs } from './SiteNotifyEvent'

const messageRef = ref('')
const actionTextRef = ref('')

let onAction: (() => void) | undefined

const toastRef = ref<HTMLElement>();

defineExpose({
  show,
})

function show(options: SiteNotifyEventArgs) {
  messageRef.value = options.message
  actionTextRef.value = options.actionText || ''
  onAction = options.onAction

  if (toastRef.value) {
    const toast = Toast.getOrCreateInstance(toastRef.value, { delay: options.timeout || 5000, autohide: true })
    toast.show()
  }
}

</script>
